import axios, { AxiosInstance, AxiosResponse } from "axios";
import queryString from "query-string";
import { useAtom } from "jotai";

export const RequestMethod = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
    PATCH: 'PATCH',
    PUT: 'PUT'
}

type RequestMethod = typeof RequestMethod[keyof typeof RequestMethod];

export type RequestProps = {
    method?: RequestMethod;
    url: string;
    query?: { [key: string]: string | number };
    headers?: any;
    params?: any;
    accessToken?: string;
    refreshToken?: string;
    fe?: boolean;
};

//Instance 관련 설정
export const instance = axios.create({
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});
const requestConfig = (config: any) => {
    const accessToken = sessionStorage.getItem("accessToken");

    if (accessToken) {
        config.headers['Authorization'] = 'Bearer ' + accessToken;
    }

    return config;
};
instance.interceptors.request.use(requestConfig);


//쿼리 파싱
const onParseQuery = (query?: { [key: string]: any } | string) => {
    if (!query) return '';
    if (typeof query === 'string') return `?${query}`;
    return '?' + queryString.stringify(query);
};

export const onRequest = async (props: RequestProps): Promise<AxiosResponse> => {
    let response: AxiosResponse;
    let axiosInstance: AxiosInstance = instance;

    try {
        response = await axiosInstance({
            method: props.method,
            url: props.url + onParseQuery(props.query),
            data: props.params,
            headers: props.headers,
        })
        return response;
    } catch (error: any) {
        return error.response || error;
    }
};